import React from 'react'
import PropTypes from 'prop-types'
import Image from 'next/image'

import { Column } from '@/components/layout'
import { Link, ContentList, Text } from '@/components/common'
import { URLS } from '@/constants'
import mappingToQuickbooksImg from '@/assets/integrations/mapping-to-quickbooks.jpg'

const IntegrationsTabsPanel = ({ name, hasDescription = false, numListItems = 3, ...rest }) => {
  const getMessageId = id => `pages.integrations.main.tabs.${name}.${id}`
  const isQuickbooks = name === 'quickbooks'
  const supportLinkName = isQuickbooks ? 'qbo' : name

  const renderSupportLink = (isSecond = false) => (<Link
    external
    messageId={getMessageId(`supportLink${isSecond ? '2' : ''}`)}
    to={URLS.support.integrations[supportLinkName]}
  />)

  return (
    <Column {...rest}>
      <Text.H2 messageProps={{ id: getMessageId('title'), values: { sup: chunks => <sup>{chunks}</sup> } }} />
      <Text.H3 bold messageId={getMessageId('subtitle')} />
      {hasDescription && <Text.P messageId={getMessageId('description')} />}
      <ContentList>
        {Array.from(Array(numListItems).keys()).map((ix) => <li key={ix}><Text messageId={getMessageId(`li${ix + 1}`)} secondary /></li>)}
      </ContentList>
      <Text.P messageProps={{
        id: 'pages.integrations.main.tabs.support',
        values: {
          link: renderSupportLink(),
          linkCount: 1,
        },
      }}
      />
      {isQuickbooks && <Image alt="mapping to quickbooks" src={mappingToQuickbooksImg} style={{ height: 'auto' }} />}
    </Column>
  )
}

IntegrationsTabsPanel.propTypes = {
  name: PropTypes.string.isRequired,
  hasDescription: PropTypes.bool,
  numListItems: PropTypes.number,
}

export default IntegrationsTabsPanel
